import { translate } from "../../translations";
import { SessionStatus, SessionTempo } from "../../types";
import { SessionProgress } from "../session/progress";

export default function Controls({
  status,
  tempo = SessionTempo.Teacher,
  startSession,
  goToResults,
  nextStatement,
  previousStatement,
  currentStatementIndex,
  statementsCount,
}: {
  status: SessionStatus;
  tempo?: SessionTempo;
  startSession?: () => void;
  goToResults?: () => void;
  nextStatement?: () => void;
  previousStatement?: () => void;
  currentStatementIndex: number;
  statementsCount: number;
}) {
  if (status === SessionStatus.Draft) {
    return (
      <button
        className="button button--secondary button--lg voting-session__control voting-session__control--center"
        onClick={startSession}
      >
        {translate("teacher.votingSession.controls.start")}
      </button>
    );
  }

  if (status === SessionStatus.Ongoing && tempo === SessionTempo.Student) {
    return (
      <>
        <button
          className="button button--secondary button--lg voting-session__control voting-session__control--center"
          onClick={goToResults}
        >
          {translate("teacher.votingSession.controls.goToResults")}
        </button>
      </>
    );
  }

  return (
    <>
      {previousStatement !== undefined && currentStatementIndex > 0 && (
        <button
          className="button button--secondary button--lg button--mobile-icon voting-session__control"
          onClick={previousStatement}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentcolor"
            className="button__icon"
          >
            <path d="M7.825 13H20V11H7.825L13.425 5.4L12 4L4 12L12 20L13.425 18.6L7.825 13Z" />
          </svg>
          <span className="button__text">
            {translate("teacher.votingSession.controls.previous")}
          </span>
        </button>
      )}
      <SessionProgress
        currentStatementIndex={currentStatementIndex}
        statementsCount={statementsCount}
      />
      {nextStatement !== undefined &&
        currentStatementIndex + 1 < statementsCount && (
          <button
            className="button button--secondary button--lg button--mobile-icon voting-session__control voting-session__control--end"
            onClick={nextStatement}
          >
            <span className="button__text">
              {translate("teacher.votingSession.controls.next")}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentcolor"
              className="button__icon"
            >
              <path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z" />
            </svg>
          </button>
        )}
      {goToResults !== undefined &&
        currentStatementIndex + 1 === statementsCount && (
          <button
            className="button button--secondary button--lg button--mobile-icon voting-session__control voting-session__control--end"
            onClick={goToResults}
          >
            <span className="button__text">
              {translate("teacher.votingSession.controls.next")}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentcolor"
              className="button__icon"
            >
              <path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z" />
            </svg>
          </button>
        )}
    </>
  );
}
